import React from "react";
import BasePage from "./BasePage";
import PreviewFormModal from "../components/PreviewFormModal/index.js";

class BaseFormPage extends BasePage {
  state = {
    object: {},
    originalObject: {},
    advanced: false,
    isPreviewOpen: false,
    pendingSubmitPayload: undefined,
  };
  componentDidMount() {
    this.presenter.componentDidMount();
  }

  getCollectionName() {
    return this.props.params?.name;
  }

  getObjectId() {
    return this.props.params && this.props.params.id;
  }

  submitWithPreview(payload) {
    this.setState({
      isPreviewOpen: true,
      pendingSubmitPayload: payload,
    });
  }

  closePreview() {
    this.setState({
      isPreviewOpen: false,
      pendingSubmitPayload: undefined,
    });
  }

  onConfirmPreview() {
    const { pendingSubmitPayload } = this.state;
    if (
      pendingSubmitPayload !== undefined &&
      pendingSubmitPayload !== null &&
      typeof this.presenter.onSubmit === "function"
    ) {
      this.presenter.onSubmit(pendingSubmitPayload);
    } else {
      this.presenter.submit();
    }
  }

  submissionSuccess() {
    this.closePreview();
    super.submissionSuccess();
  }

  submissionError(error) {
    this.closePreview();
    super.submissionError(error);
  }

  onSubmitForm(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
      this.submitWithPreview();
    } else {
      this.submitWithPreview(e);
    }
  }

  onClickBack() {
    this.presenter.onClickBack();
  }

  setObject(object) {
    const hasId = object?.id != null;
    const hasOriginal = this.state.originalObject?.id != null;
    if (hasId && !hasOriginal) {
      this.setState({
        object,
        originalObject: JSON.parse(JSON.stringify(object)),
      });
    } else {
      this.setState({ object });
    }
  }

  onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  hasActualChanges() {
    return this.presenter.hasActualChanges();
  }

  getPreviewExcludeFields() {
    return [];
  }

  renderPreviewModal() {
    const {
      isPreviewOpen,
      object,
      originalObject,
      pendingSubmitPayload,
      submitting,
    } = this.state;
    const schema = this.getSchema(this.getCollectionName());
    const schemas = this.getSchemas();

    const previewObject =
      pendingSubmitPayload !== undefined && pendingSubmitPayload !== null
        ? pendingSubmitPayload
        : object;

    if (!schema) return null;
    return (
      <PreviewFormModal
        isOpen={isPreviewOpen}
        schema={schema}
        object={previewObject}
        originalObject={originalObject}
        schemas={this.getSchemas()}
        progress={submitting}
        title="Preview"
        onClose={this.closePreview.bind(this)}
        onConfirm={this.onConfirmPreview.bind(this)}
        confirmText="Confirm"
        cancelText="Cancel"
        description="Kindly verify the details below before proceeding."
        excludeFields={this.getPreviewExcludeFields()}
      />
    );
  }
}

export default BaseFormPage;
